import React, { useCallback, useMemo } from 'react';

import { useAppDispatch, useAppSelector } from 'store/hooks';
import { RootState } from 'store/types';
import { setSortingObject } from 'store/table';

import { ReactComponent as ArrowUp } from 'assets/arrowUp.icon.svg';
import { ReactComponent as ArrowDown } from 'assets/arrowDown.icon.svg';

import { SortingTypes } from '../types';

import useStyles from '../styles';

interface IProps {
  sortable: boolean;
  fieldName: string;
}

const SortingArrow: React.FC<IProps> = ({ sortable, fieldName }) => {
  const classes = useStyles();
  const dispatch = useAppDispatch();
  const { sorting } = useAppSelector((state: RootState) => state.table);

  const disabled = useMemo(() => sorting.field !== fieldName, [sorting, fieldName]);

  const handleStateChange = useCallback(
    (sortingOrder: SortingTypes): void => {
      dispatch(
        setSortingObject({
          field: fieldName,
          order: sortingOrder,
        }),
      );
    },
    [fieldName],
  );

  return (
    <div className={disabled ? classes.disabled : classes.active}>
      {sortable && sorting.field !== fieldName && (
        <ArrowUp
          onClick={() => {
            handleStateChange(SortingTypes.ASC);
          }}
        />
      )}

      {sortable && sorting.field === fieldName && (
        <>
          {sorting.order !== SortingTypes.ASC ? (
            <ArrowUp
              onClick={() => {
                handleStateChange(SortingTypes.ASC);
              }}
            />
          ) : (
            <ArrowDown
              onClick={() => {
                handleStateChange(SortingTypes.DESC);
              }}
            />
          )}
        </>
      )}
    </div>
  );
};

export default SortingArrow;
